import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api/client";
import type {
  KbPermissionRow,
  KbPermissionUpsert,
} from "@/api/types";

const KEY = (kbId: string) => ["kb-permissions", kbId] as const;

export function useKbPermissions(kbId: string) {
  return useQuery({
    queryKey: KEY(kbId),
    queryFn: () =>
      api.GET<KbPermissionRow[]>(`/knowledge-bases/${kbId}/permissions`),
    enabled: Boolean(kbId),
  });
}

export function useGrantKbPermission(kbId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: KbPermissionUpsert) =>
      api.POST<KbPermissionRow>(
        `/knowledge-bases/${kbId}/permissions`,
        payload,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY(kbId) });
    },
  });
}

export function useRevokeKbPermission(kbId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (teamId: string) =>
      api.DELETE(`/knowledge-bases/${kbId}/permissions/${teamId}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY(kbId) });
    },
  });
}
